import { useEffect } from "react";

const DEFAULT_TITLE = "Your Classic Style — Marketplace";
const OG_DEFAULT_TITLE = "Your Classic Style — Vintage & Classic Marketplace";
const DEFAULT_DESC =
  "Your Classic Style — a curated peer-to-peer marketplace for apparel, footwear and accessories from infant to adult.";
const DEFAULT_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/b4be43f3-2601-441c-9078-02b7f7e5431f/images/2e06c15ec40ce33fd86122152648a27c06c5bd9d9861a1456dd62ac9c3404a6b.jpeg";

function setMeta(selector, value) {
  const el = document.head.querySelector(selector);
  if (el) el.setAttribute("content", value);
}

// Dynamically set the page <title>, description, Open Graph image and Product JSON-LD
// so each product & category page has its own crawlable metadata + rich snippet.
export function useSeo({ title, description, image, url, jsonLd } = {}) {
  useEffect(() => {
    const t = title || DEFAULT_TITLE;
    const d = (description || DEFAULT_DESC).replace(/\s+/g, " ").trim().slice(0, 160);
    const img = image || DEFAULT_IMAGE;
    const u = url || (typeof window !== "undefined" ? window.location.href : "");
    document.title = t;
    setMeta('meta[name="description"]', d);
    setMeta('meta[property="og:title"]', t);
    setMeta('meta[property="og:description"]', d);
    setMeta('meta[property="og:image"]', img);
    if (u) setMeta('meta[property="og:url"]', u);
    setMeta('meta[name="twitter:title"]', t);
    setMeta('meta[name="twitter:description"]', d);
    setMeta('meta[name="twitter:image"]', img);

    let script;
    if (jsonLd) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = "seo-jsonld";
      script.text = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }

    return () => {
      document.title = DEFAULT_TITLE;
      setMeta('meta[name="description"]', DEFAULT_DESC);
      setMeta('meta[property="og:title"]', OG_DEFAULT_TITLE);
      setMeta('meta[property="og:description"]', DEFAULT_DESC);
      setMeta('meta[property="og:image"]', DEFAULT_IMAGE);
      setMeta('meta[property="og:url"]', "https://yourclassicstyle.com/");
      setMeta('meta[name="twitter:title"]', OG_DEFAULT_TITLE);
      setMeta('meta[name="twitter:description"]', DEFAULT_DESC);
      setMeta('meta[name="twitter:image"]', DEFAULT_IMAGE);
      if (script && script.parentNode) script.parentNode.removeChild(script);
    };
  }, [title, description, image, url, jsonLd]);
}
